// walletToGradient.ts

const PROFILE_GRADIENTS = [
    ["#B3B3B6", "#9E9EA2"],
    ["#FF98B0", "#FF7A9A"],
    ["#FF7F77", "#FF5B51"],
    ["#FFB76A", "#FFA542"],
    ["#FED771", "#FECB43"],
    ["#8DE597", "#6DDE7D"],
    ["#94DAFB", "#74D1FB"],
    ["#BBA8FA", "#A88FF8"],
] as const; // TOP-LEFT AND BOTTOM-RIGHT

export type Gradient = (typeof PROFILE_GRADIENTS)[number]; // readonly [string, string]

export function fnv1a32(str: string): number {
    let hash = 0x811c9dc5; // 32-bit offset basis
    for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i);
        hash = (hash * 0x01000193) >>> 0; // 32-bit FNV prime, keep unsigned
    }
    return hash;
}

export function walletToGradient(address: string | null | undefined): Gradient {
    // empty / null address → first gradient as a safe fallback
    if (!address) return PROFILE_GRADIENTS[0];

    const hash = fnv1a32(address.toLowerCase());
    const idx = hash % PROFILE_GRADIENTS.length; // 0 – 7
    return PROFILE_GRADIENTS[idx]!; // never undefined
}

const DARK_USERNAME_BACKGROUNDS = [
    "#3A3A3B",
    "#592E38",
    "#592421",
    "#593D1E",
    "#594920",
    "#2C4F30",
    "#2E4B58",
    "#3E3757",
] as const;

export function walletToDarkUsernameBackground(
    address: string | null | undefined,
): string {
    if (!address) return DARK_USERNAME_BACKGROUNDS[0];
    const hash = fnv1a32(address.toLowerCase());
    const idx = hash % DARK_USERNAME_BACKGROUNDS.length; // 0 – 7
    return DARK_USERNAME_BACKGROUNDS[idx]!; // never undefined
}
